export const ExternalLinks = {
  ACCESS_REQUEST:
    "https://oceanpact.fluigidentity.com/ui/login-saml?forward=%2fSPInitPost%2freceiveSSORequest%2f6e67704b1b8e11eab9e80a58646001b3%2f0df8754228c011eaa1370a58646001dd?samlRequestId%3D9144754a-5c4a-4cb6-a46e-68ba69a565fd",
} as const;
